import clsx from "clsx";
import type { RefinementListProvided } from "react-instantsearch-core";
import { twMerge } from "tailwind-merge";

interface IToggableRefinementListProps {
  items: RefinementListProvided["items"];
  refine: RefinementListProvided["refine"];
}

export default function ToggableRefinementList({ items, refine }: IToggableRefinementListProps) {
  return (
    <ul className="space-y-4">
      {items.map(({ isRefined, value, label, count }) => {
        return (
          <li key={label}>
            <button
              type="button"
              onClick={() => refine(value)}
              className={twMerge(
                "group",
                "m-0 cursor-pointer p-0 text-sm font-normal tracking-wide text-slate-500",
                "flex w-full items-center justify-between",

                clsx({
                  "font-bold text-violet-600": isRefined,
                }),
              )}
            >
              <div className="mr-6 overflow-hidden text-ellipsis whitespace-nowrap">{label.trim()}</div>

              <div
                className={twMerge(
                  "group relative",
                  "before:absolute before:-inset-1.5 before:rounded-md before:bg-violet-50 before:opacity-0",
                  "text-slate-500",
                  clsx({
                    "text-violet-600 before:opacity-100": isRefined,
                  }),
                )}
              >
                <span className="relative select-none text-sm font-bold">{count}</span>
              </div>
            </button>
          </li>
        );
      })}
    </ul>
  );
}
